import { api } from "@/lib/api";

const KEY = "rpopro_site_chat";
export const HANDOFF_EMAIL = "tina@rpopro.co";
export const GREETING = { role: "assistant", content: "Hi! I'm the RPOPRO assistant. Ask me anything about plans, the free resume scan, or how RPOPRO works. If you'd like a person, just say so." };

export const loadChat = () => { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; } };
export const saveChat = (c) => localStorage.setItem(KEY, JSON.stringify(c));
export const clearChat = () => localStorage.removeItem(KEY);

// Spec §29a. Returns {session_id, reply, handoff, collected} or {offline:true} when the route isn't live.
export const sendChat = async ({ session_id, message, visitor }) => {
  try {
    const { data } = await api.post("/public/chat", { session_id, message, page: window.location.pathname, visitor });
    return data;
  } catch (e) {
    if (e.response?.status === 404) return { offline: true };
    throw e;
  }
};

export const transcript = (msgs) => msgs.map((m) => `${m.role === "user" ? "Visitor" : "Assistant"}: ${m.content}`).join("\n\n");

// Spec §29b. Falls back to a prefilled email when the route isn't live.
export const sendHandoff = async ({ session_id, contact, messages }) => {
  try {
    const { data } = await api.post("/public/chat/handoff", { session_id, ...contact, page: window.location.pathname, transcript: messages });
    return { ok: true, ...data };
  } catch (e) {
    if (e.response?.status !== 404) throw e;
    const body = `Name: ${contact.name}\nEmail: ${contact.email}${contact.phone ? `\nPhone: ${contact.phone}` : ""}${contact.note ? `\nNote: ${contact.note}` : ""}\nPage: ${window.location.pathname}\n\n${transcript(messages)}`;
    window.location.href = `mailto:${HANDOFF_EMAIL}?subject=${encodeURIComponent(`Chat handoff: ${contact.name}`)}&body=${encodeURIComponent(body.slice(0, 1800))}`;
    return { ok: true, mailto: true };
  }
};
